import { render, staticRenderFns } from "./SsmlEditor.vue?vue&type=template&id=a873cd3a&scoped=true"
import script from "./SsmlEditor.vue?vue&type=script&lang=js"
export * from "./SsmlEditor.vue?vue&type=script&lang=js"
import style0 from "./SsmlEditor.vue?vue&type=style&index=0&id=a873cd3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a873cd3a",
  null
  
)

export default component.exports